import { ReactNode } from 'react';

import { ApiContext } from '../contexts/ApiContext';
import { jsonApiClient } from '../httpClient';
import { createJsonApiClient } from '../utils/createJsonApiClient';

export const ApiProvider = ({ children }: { children: ReactNode }) => {
  const jsonApi = createJsonApiClient(jsonApiClient);
  return (
    <ApiContext.Provider value={{ jsonApi }}>{children}</ApiContext.Provider>
  );
};
